import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchMetaConnectionStatus } from "../../api/growthEngine/metaConnection.api";

export const META_CONNECTION_STATUS_ROOT = "meta-connection-status";

export const metaConnectionStatusQueryKey = (userKey) => [
    META_CONNECTION_STATUS_ROOT,
    userKey,
];

export const invalidateMetaConnectionStatus = (queryClient) =>
    queryClient.invalidateQueries({ queryKey: [META_CONNECTION_STATUS_ROOT] });

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export const useMetaConnectionStatus = ({ userKey, enabled = true } = {}) =>
    useQuery({
        queryKey: metaConnectionStatusQueryKey(userKey),
        queryFn: fetchMetaConnectionStatus,
        enabled: enabled && !!userKey,
        staleTime: FIVE_MINUTES_MS,
        refetchOnWindowFocus: false,
        retry: 1,
    });
